import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/doctor-schedules',
  name: 'doctorSchedulesMenu',
  component: Layout,
  meta: {
    title: '出诊管理',
    icon: 'i-lucide:calendar-clock',
  },
  children: [
    {
      path: 'arrangements',
      name: 'doctorScheduleArrangements',
      component: () => import('@/views/doctor_schedules/index.vue'),
      meta: { title: '排班规则', icon: 'i-lucide:calendar-days' },
    },
    {
      path: 'records',
      name: 'doctorScheduleRecords',
      component: () => import('@/views/doctor_schedules/index.vue'),
      meta: { title: '出诊看板', icon: 'i-lucide:clipboard-list' },
    },
  ],
}

export default routes
